<!--<div>
    <h4><u>Section 5: Payment Method</u> </h4>
    <br>
    <br>
</div>-->
<div class="row">
    <div class="col-16">
        <p>
            You can pay your monthly plan premium (including any late enrollment penalty you may owe) by automatic deduction from your monthly Social Security or Railroad Retirement Board benefit check, automatic bank draft withdrawal, credit card, or by mail.
        </p> <p>
                 <strong>  Please select a premium payment option.</strong> (If you don’t select an option, you will receive a monthly bill.)
        </p> <p>
                 <strong> Reminder,</strong> if you have secondary coverage that pays for part of your premiums (for example: from your employer or an SPAP) then you must choose monthly bills that you can pay by mail in order for the secondary coverage to be applied correctly.
        </p>
    </div>
</div>

<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <ValidatedRadioButtonGroup [label]="''"
                                       [options]="paymentOptions"
                                       [selectedValue]="paymentOption"
                                       [radioGroupName]="'PaymentOptions'"
                                       [disabled]="disabled"
                                       (onValueChange)="paymentOptionChanged($event)">
            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>

<div *ngIf="this.paymentOption === 'Deduction from Social Security Check'">
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p><strong>Please have your client acknowledge the following:</strong></p>
                <p>
                    {{orgName}} will deduct your monthly premium from your Social Security check (or Railroad Retirement Board for those who qualify) automatically. Your request for Automatic Deduction will be submitted for the next available payment cycle. <b>Please Note:</b> This may take two or more months to begin once approved by Centers for Medicare and Medicaid Services, and will not cover any premiums for which we have already sent you an invoice, so please continue to pay your premium invoice as long as you receive it. Do not select this option if another entity (such as an Employer Group or State Pharmaceutical Assistance Program) is paying part of your premium.If Social Security/the Railroad Retirement Board does not approve your request for automatic deduction, we will send you a paper bill for your monthly premiums.
                </p>
            </div>
        </div>
    </div>
</div>

<div *ngIf="this.paymentOption === 'Deduction from Railroad Retirement Board'">
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p><strong>Please have your client acknowledge the following:</strong></p>
                <p>
                    {{orgName}} will deduct your monthly premium from your Social Security check (or Railroad Retirement Board for those who qualify) automatically. Your request for Automatic Deduction will be submitted for the next available payment cycle. <b>Please Note:</b> This may take two or more months to begin once approved by Centers for Medicare and Medicaid Services, and will not cover any premiums for which we have already sent you an invoice, so please continue to pay your premium invoice as long as you receive it. Do not select this option if another entity (such as an Employer Group or State Pharmaceutical Assistance Program) is paying part of your premium.If Social Security/the Railroad Retirement Board does not approve your request for automatic deduction, we will send you a paper bill for your monthly premiums.
                </p>
            </div>
        </div>
    </div>
</div>


<div class="row">
    <div class="col-24">
        <div id="payment-account-section"
             *ngIf="this.accountInfoFormIsVisible()">
            <PaymentAccountForm [paymentAccount]="paymentAccount"
                                [disabled]="disabled"
                                (onValueChange)="this.paymentFormChange($event)">
            </PaymentAccountForm>   
            <div class="row">
                <div class="col-24">
                    <p>
                        {{orgName}} will withdraw your premium from your bank account automatically. To sign up, please include a VOIDED check or savings account direct deposit form from your bank with your enrollment form. <br/>Your request for premium deduction will be submitted for the next available payment cycle. It may take one or more months for your deduction to begin. Please continue to pay your premium invoice as long as you receive it. If this request is received without a VOIDED check or savings account direct deposit form, your Automatic Bank Draft Withdrawal may not be processed. <br/><i>By selecting Automatic Bank Withdrawal, I authorize the bank or financial organization on the enclosed check to pay my premium through electronic bank withdrawal payable to {{AetnaorgName}}. I authorize the deduction of up to $300 per month to settle my current balance due. The bank or other financial organization will be fully protected in honoring these payments until written notice from me canceling this request is received at the address listed at the end of this form.</i>
                    </p>

                </div>

            </div>
        </div>
    </div>
</div>
<div *ngIf="this.paymentOption === 'Direct Bill'">
    <div class="row">
        <div class="col-16">
            <p>You will be mailed a premium invoice each month. <strong> Do not send payment with this enrollment form.</strong></p>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-16">
        <div class="partition bottom-20">
            <p class="bottom-20">
                <strong>Note,</strong> the option to pay using a <strong>Credit Card</strong> can be
                started after your
                enrollment in the plan. You can call us toll free once your enrollment in the plan is active, at:
                <a class="tel-no" href="tel:+18668244055" nowrap>1-866-824-4055,</a> 24 hours a day, 7 days a week. TTY users call 711.
            </p>
            <p>
                People with limited incomes may qualify for Extra Help to pay for their prescription
                drug costs. If you
                qualify, Medicare could pay for 75% or more of your drug costs including monthly prescription drug premiums,
                annual deductibles and co-insurance. Additionally, those who qualify won’t have a coverage gap or a late
                enrollment penalty.
            </p>
            <p>
                Many people are eligible for these savings and don’t even know it. For more
                information about this Extra
                Help, contact your local Social Security office, or call Social Security at <a class="tel-no" href="tel:+18007721213">1-800-772-1213.</a> TTY users should
                call <a class="tel-no" href="tel:+18003250778">1-800-325-0778.</a> You can also apply for Extra Help online at <strong>
                    <a href="https://www.ssa.gov/medicare/prescriptionhelp/" target="_blank">www.socialsecurity.gov/prescriptionhelp.</a>
                </strong>
                If you qualify for Extra Help with your Medicare prescription drug coverage costs, Medicare will pay all or
                part of your plan premium. If Medicare pays only a portion of this premium, we will bill you for the amount
                that Medicare does not cover.
            </p>
            <p>
                <i>
                    If you are assessed a Part D-Income Related Monthly Adjustment Amount, you will be
                    notified by the Social
                    Security Administration. You will be responsible for paying this extra amount in addition to your plan
                    premium. You will either have the amount withheld from your Social Security or Railroad Retirement Board
                    benefit check or be billed directly by Medicare. Do NOT pay the Part D-IRMAA extra amount to {{orgName}}.
                </i>
            </p>
        </div>
    </div>
</div>
